import { render, staticRenderFns } from "./diy2.vue?vue&type=template&id=bddd1642"
import script from "./diy2.vue?vue&type=script&lang=js"
export * from "./diy2.vue?vue&type=script&lang=js"
import style0 from "./diy2.vue?vue&type=style&index=0&id=bddd1642&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports